import React from 'react';
import { Box, Typography } from '@mui/material';
import LineArchiveSvg from '../../../../assets/svg-fc/LineArchiveSvg';
import './archivedEmptyState.scss';

const ArchivedEmptyState: React.FC = () => (
  <Box className="archivedEmptyState">
    <Box className="archivedEmptyStateIcon">
      <LineArchiveSvg size={28} />
    </Box>
    <Typography className="archivedEmptyStateTitle">No archived chats</Typography>
    <Typography className="archivedEmptyStateDescription">Chats you archive will appear here.</Typography>
  </Box>
);

export default ArchivedEmptyState;
